import React from "react";
import style from "./style.module.css";

const Placeholder = ({ width = "width100", type = false, classes = false }) => {
    const classNames = `${style.skeleton} ${style.animatepulse}${type !== false ? ` ${style[type]}` : ''}${width !== false ? ` ${style[width]}` : ''}${classes !== false ? ` ${classes}` : ''}`
    return <div className={classNames}></div>
}
export default Placeholder;